"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactiveClassDocs = void 0;
const core_1 = require("@beautiful-eyes/core");
const reactive_class_template_be_1 = __importDefault(require("./reactive-class.template.be"));
require("./demo-counter.component");
require("./demo-effect-log.component");
let ReactiveClassDocs = (() => {
    let _classDecorators = [(0, core_1.Component)({
            selector: 'ReactiveClassDocs',
            useTemplate: reactive_class_template_be_1.default,
            useStyleSheets: []
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = core_1.ReactiveClass;
    var ReactiveClassDocs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.stateSample = `class TodoList extends ReactiveClass {
    @State() items = [{ id: 1, label: 'Write docs', done: false }];
    @State() filter = 'all';
}

// mutating in place is enough to trigger a re-render:
list.items.push({ id: 2, label: 'Ship it', done: false });
list.items[0].done = true;`;
            this.effectSample = `class Counter extends ReactiveClass {
    @State() count = 0;

    // a plain field, not @State: this effect runs inside a reactive pass
    // that will already refresh every binding afterward, so a plain
    // mutation here is picked up for free
    log: string[] = [];

    @Effect((ctx: Counter) => [ctx.count])
    onCountChange(previous: number | undefined){
        const message = previous === undefined
            ? \`initial count is \${this.count}\`
            : \`count changed from \${previous} to \${this.count}\`;
        this.log = [message, ...this.log].slice(0, 4);
    }
}`;
            this.computedSample = `class TodoList extends ReactiveClass {
    @State() items = [];

    @Computed()
    get remaining(){
        return this.items.filter(i => !i.done).length;
    }
}`;
            this.inputSample = `class TodoItem extends ReactiveClass {
    @Input() label = '';
    @Input() done = false;
}`;
        }
    };
    __setFunctionName(_classThis, "ReactiveClassDocs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        ReactiveClassDocs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return ReactiveClassDocs = _classThis;
})();
exports.ReactiveClassDocs = ReactiveClassDocs;
